import '../images/favicons/manifest.json';
import.meta.glob([
    '../images/**',
]);

import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.min.css';

//Imported JS
import './bootstrap';
import 'imagesloaded';

//Imported CSS
import 'flatpickr/dist/flatpickr.min.css'

import './chart_options'
import _ from 'lodash';
window._ = _;
